// extracted by mini-css-extract-plugin
export default {"tariffsList":"style_tariffsList__owrLC","title":"style_title__otIvV","tariffsHeader":"style_tariffsHeader__yixRV","tariffs":"style_tariffs__oY3uF","text":"style_text__Qnl+2"};